export const QUERY_PARAMS = {
    'accountNumber' : 'Account Number',
    'lockboxNumber' : 'Lockbox Number',
    'lockboxSite' : 'Lockbox Site',
    'processedDateRange': 'Processed Date Range',
    'batchNumberFrom': 'Batch Number Range',
    'batchAmountFrom': 'Batch Amount Range',
    'batchNumber': "Batch Number",
    'checkNumberFrom': 'Check Number Range',
    'amountFrom': 'Amount Range',
    'abaRoutingNumber': 'ABA/RT',
    'checkingAccountNumber': 'Checking Account Number',
    'customerIdentifier': 'Customer Identifier',
    'payeeName': 'Payee Name',
    'invoiceNumber': 'Invoice Number',
    'currency': 'Currency',
    'processedDate': 'Processed Date',
    'totalItems': 'Total Items',
    'totalAmount': 'Deposit Total'
}